module.exports = __webpack_public_path__ + "img/project.dce02376.png";